// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"07ef831e","273":"0fa79aec","319":"368afab3","383":"4246ce3b","635":"1456b7ff","880":"cb77126c"}[chunkId] + ".chunk.js";
};